
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2","y":"3","width":"12","height":"11","rx":"2","stroke":"currentColor","stroke-width":"1.4"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"1.4","d":"M2 7h12"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"1.4","stroke-linecap":"round","d":"M5 1.5v3M11 1.5v3"}})])
          )
        }
      }
    